export default class CountryList extends HTMLElement {
  constructor() {
    super();

    this.$buttons = document.querySelectorAll('[data-toggle="country-list"]');
    this.$texts = document.querySelectorAll('[data-text="country"]');
    this.$countryNav = this.querySelector(".country-list__nav");

    this.$container = this.querySelector("div");

    this.state = {
      height: this.$container.offsetHeight,
      isShow: false,
      country: null,
      eunion: [
        "AT",
        "BE",
        "BG",
        "HR",
        "CY",
        "CZ",
        "DK",
        "EE",
        "FI",
        "FR",
        "DE",
        "GR",
        "HU",
        "IE",
        "IT",
        "LV",
        "LT",
        "LU",
        "MT",
        "NL",
        "PL",
        "PT",
        "RO",
        "SK",
        "SL",
        "SE",
        "ES",
      ],
    };
  }

  connectedCallback() {
    this.fetchClientCountry();

    window.addEventListener("resize", () => this.resetState());

    this.$buttons.forEach((button) => {
      button.addEventListener("click", (e) => this.handleToggle(e));
    });
  }

  disconnectedCallback() {
    window.removeEventListener("resize", () => this.resetState());

    this.$buttons.forEach((button) => {
      button.removeEventListener("click", (e) => this.handleToggle(e));
    });
  }

  // Setters
  setState(nextState) {
    this.state = {
      ...this.state,
      ...nextState,
    };

    this.render();
  }

  resetState() {
    this.setState({
      height: this.$container.offsetHeight,
    });
  }

  // Fetchers
  async fetchClientCountry() {
    try {
      let country = this.getActiveRegionTitleByDomain(window.location.host);

      if (!country && window.languages.regions) {
        switch (Shopify.shop) {
          case "https-satorisan-com.myshopify.com":
            country = window.languages.regions.es;
            break;
          case "satorisan-eu.myshopify.com":
            country = window.languages.regions.eu;
            break;
          default:
            country = window.languages.regions.row;
        }
      }

      this.setState({
        country,
      });
    } catch (error) {
      console.log(error);
    }
  }

  getActiveRegionTitleByDomain(domain) {
    const listItem = Array.from(this.$countryNav.querySelectorAll("a")).find(
      ($elem) => {
        return $elem.href.includes(domain);
      }
    );

    return listItem?.textContent;
  }

  // Handlers
  handleToggle() {
    this.setState({
      isShow: !this.state.isShow,
    });
  }

  // Renderers
  render() {
    if (this.state.isShow) {
      this.style.height = `${this.state.height}px`;
    } else {
      this.style.height = `0px`;
    }

    if (this.state.country) {
      this.$texts.forEach(($text) => {
        $text.textContent = this.state.country;
      });
    }
  }
}
